import React from 'react';

type Props = {
  color?: string;
};

const defaultProps = {
  color: '#B4B4B4',
};

const FavoriteIcon: React.FC<Props> = function FavoriteIcon({ color }) {
  return (
    <svg width="18px" height="15px" viewBox="0 0 15 14" version="1.1" xmlns="http://www.w3.org/2000/svg">
      <g id="Dev-Ready-prototype" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g id="News-Article-Spacing" transform="translate(-578.000000, -513.000000)" fill={color} fillRule="nonzero">
          <g id="Group-21" transform="translate(220.000000, 259.000000)">
            <g id="Group-52" transform="translate(16.000000, 254.000000)">
              <g id="326703_favorite_rate_star_icon" transform="translate(342.000000, 0.000000)">
                <polygon id="Shape" points="7.21052632 11.0126368 11.6666316 13.7 10.4877105 8.63172105 14.4210526 5.22330526 9.23596316 4.77841579 7.21052632 0 5.18508947 4.77841579 0 5.22330526 3.93334211 8.63172105 2.75442105 13.7" />
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
};

FavoriteIcon.defaultProps = defaultProps;
export default FavoriteIcon;
